import { Route, Routes } from "react-router-dom";

import AccountLvlAuthorizationListScreen from "screens/App/CRM/Authorization/AccountLvlAuthorizationListScreen";
import EntityLvlAuthorizationListScreen from "screens/App/CRM/Authorization/EntityLvlAuthorizationListScreen";

const AuthorizationRouter = () => {
  return (
    <Routes>
      <Route path="list">
        <Route path="account" element={<AccountLvlAuthorizationListScreen />} />
        <Route path="entity" element={<EntityLvlAuthorizationListScreen />} />
      </Route>
    </Routes>
  );
};

export default AuthorizationRouter;
